import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface UserGroupOutlineSvgProps extends Omit<SvgWrapperProps, 'children'> {}

export const UserGroupOutlineSvg = ({
  ...svgProps
}: UserGroupOutlineSvgProps) => (
  <SvgWrapper viewBox="0 0 18 18" {...svgProps}>
    <path d="M12 2C14.2091 2 16 3.79086 16 6C16 7.2582 15.419 8.381 14.5107 9.11426C16.5093 9.57297 18 11.3623 18 13.5V14.5C18 15.3284 17.3284 16 16.5 16H13.0947C13.2709 15.6959 13.3977 15.3596 13.458 15H16.5C16.7761 15 17 14.7761 17 14.5V13.5C17 11.567 15.433 10 13.5 10H12.3721C12.1021 9.62499 11.7909 9.2817 11.4434 8.97852L11.3955 8.93945C11.5907 8.97939 11.793 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C11.5616 3 11.1459 3.09565 10.7705 3.26465C10.6009 2.96956 10.405 2.69195 10.1855 2.43457C10.7302 2.15686 11.3467 2 12 2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 6C10 7.2582 9.41908 8.38073 8.51082 9.11398C10.5094 9.5727 12 11.3623 12 13.5V14.5C12 15.3284 11.3284 16 10.5 16H1.5C0.671573 16 0 15.3284 0 14.5V13.5C0 11.3623 1.49063 9.5727 3.48918 9.11398C2.58092 8.38073 2 7.2582 2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM4.5 10H7.5C9.433 10 11 11.567 11 13.5V14.5C11 14.7761 10.7761 15 10.5 15H1.5C1.22386 15 1 14.7761 1 14.5V13.5C1 11.567 2.567 10 4.5 10Z"
    />
  </SvgWrapper>
);
